import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Row } from "./RowsTableAdmins";
import { Box, TablePagination } from "@mui/material";
import ModalDetailsAdmin from "../ModalDetailsAdmin";
// import ModalDetailsUser from "../ModalDetailsUser";

export default function TableAdmins({ rows = [], setLoading, type }) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [showModalDetailsAdmin, setShowModalDetailsAdmin] =
    React.useState(false);
  const [selectedUser, setSelectedUser] = React.useState(null);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const visibleRows = React.useMemo(() => {
    if (!rows || rows.length === 0) return [];

    return rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  }, [page, rowsPerPage, rows]);
  return (
    <>
      {selectedUser && (
        <ModalDetailsAdmin
          open={showModalDetailsAdmin}
          setOpen={setShowModalDetailsAdmin}
          adminData={selectedUser}
          setLoading={setLoading}
        />
      )}
      <Box sx={{ width: "100%" }}>
        <Paper sx={{ width: "100%", mb: 2 }}>
          <TableContainer component={Paper}>
            <Table aria-label="collapsible table">
              <TableHead>
                <TableRow>
                  <TableCell />
                  {/* <TableCell>ID</TableCell> */}
                  <TableCell align="center">ID</TableCell>
                  <TableCell align="center">Nombre de Usuario</TableCell>
                  <TableCell align="center">Rol</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {visibleRows.map((row) => {
                  return (
                    <Row
                      key={row._id}
                      row={row}
                      setSelectedUser={setSelectedUser}
                      setShowModalUser={setShowModalDetailsAdmin}
                    />
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </Box>
    </>
  );
}
